import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { AuthorizationIdamStateService } from '~app/modules/authorization/services/authorization-idam-state.service';
import { ActivationEnd, Router } from '@angular/router';
import { combineLatest } from 'rxjs';
import { filter } from 'rxjs/operators';
import { AuthorizationStateType } from '~app/modules/authorization/constants/authorization.constant';
import { AuthorizationState } from '~app/modules/authorization/models/authorization-state.model';
import { isPlatformServer } from '@angular/common';
import { HomepageNavigatorService } from '~shared/modules/homepage-navigator/homepage-navigator.service';

@Injectable({
  providedIn: 'root',
})
export class IdamLogoutListenerService {
  constructor(
    private readonly router: Router,
    private readonly homepageNavigator: HomepageNavigatorService,
    private readonly authIdamState: AuthorizationIdamStateService,
    // eslint-disable-next-line @typescript-eslint/ban-types
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  public initLogoutListener() {
    if (isPlatformServer(this.platformId)) {
      return;
    }
    combineLatest([
      this.router.events.pipe(filter((e) => e instanceof ActivationEnd)),
      this.authIdamState.state$,
    ]).subscribe(([event, state]: [ActivationEnd, AuthorizationState]) => {
      const leaveOnLogout = event.snapshot.data.leaveOnLogout === true;
      if (leaveOnLogout && state.type === AuthorizationStateType.LoggedOut) {
        this.homepageNavigator.navigateToHomepage().subscribe();
      }
    });
  }
}
